import { Service } from '@angular/core';

@Service()
export class TermsAcknowledgmentService {

  private readonly TERMS_ACCEPT_KEY: string = 'RatingsTermsResponse';

  constructor() {
  }

  acceptTerms(): void {
    sessionStorage.setItem(this.TERMS_ACCEPT_KEY, 'true');
  }

  areRatingTermsAcknowledged(): boolean {
    return 'true' === sessionStorage.getItem(this.TERMS_ACCEPT_KEY);
  }

}
